import { render, staticRenderFns } from "./AmetrasPaginationTemplate.vue?vue&type=template&id=88647a44&"
import script from "./AmetrasPaginationTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasPaginationTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
